<template>
  <v-container grid-list-md class="pa-5">
    <m-breadcrum :items="bread"></m-breadcrum>
    <v-row v-if="grup">
      <v-col cols="12">
        <m-card :title="'Grup ' + grup.nama">
          <v-tabs show-arrows grow v-model="tabDetil">
            <v-tab v-for="item in itemDetils" :key="item.tab">{{ item.tab }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabDetil">
            <v-tab-item>
              <ListKelas :addData="isCan('kelas')" :items="grup.kelas" @reload="load" />
            </v-tab-item>
            <v-tab-item>
              <v-row>
                <v-col cols="12">
                  <InstrukturTerpilih title="Instruktur Terpilih" :items="grup.jadwalinstruktur" @load="loadKandidat" />
                </v-col>
                <v-col cols="12">
                  <InstrukturKandidat ref="kandidat" :changeData="change" title="Daftar Instruktur" @load="load" />
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </m-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ListKelas from "../../grup/components/Kelas.vue";
import InstrukturKandidat from "../../grup/components/InstrukturKandidat.vue";
import InstrukturTerpilih from "../../grup/components/InstrukturTerpilih.vue";
export default {
  components: {
    ListKelas,
    InstrukturKandidat,
    InstrukturTerpilih
  },
  data() {
    return {
      grup: {},
      kandidats: [],
      itemsKandidats: [],
      change: false,
      tab: 3,
      tabDetil: 0,
      tabDetils: 2,
      itemDetils: [
        { tab: "Daftar Kelas", content: "Daftar Kelas" },
        { tab: "Jadwal Instruktur", content: "Jadwal Instruktur" }
      ],
      items: [
        { tab: "Peserta", content: "Peserta" },
        { tab: "Fasilitator", content: "Fasilitator" },
        { tab: "Pendamping", content: "Pendamping" },
        { tab: "Admin grup", content: "Admin grup" },
        { tab: "Instruktur", content: "Instruktur" },
        { tab: "Narasumber", content: "Narasumber" },
        { tab: "Admin Pusat", content: "Admin Pusat" }
      ]
    };
  },
  activated() {
    this.load();
  },
  methods: {
    add(kelas_modul_id) {
      this.$refs.dlgGrouping.open({}, kelas_modul_id).then(() => {
        this.load();
      });
    },
    loadKandidat() {
      this.$refs.kandidat.load();
      this.load();
    },
    load() {
      return this.$store
        .dispatch("grup/detil", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          grup_id: this.$route.params.grup_id
        })
        .then(res => {
          this.grup = res;
        })
        .catch(e => e);
    },

    toLMS(val) {
      window.open(val.link_moodle, "_blank");
    }
  },
  computed: {
    bread() {
      return [
        {
          icon: "mdi-library-books",
          title: "Kelola Grup",
          to: { name: "grup", params: { instansi_id: this.instansi_id } }
        },
        {
          icon: "mdi-edit",
          title: this.grup ? this.grup.nama : "-"
        }
      ];
    },
    kelasmodul() {
      return this.$store.getters["grup/grouping"];
    }
  }
};
</script>
